import { DistributionReason } from "./DistributionReason";

export class IraFields {
    isIraTransaction: boolean;
    isAccountTaxable: boolean;
    hasActiveTaxElections: boolean;
    fedTaxPercent: string; //this is not actually received from the API
    fedTaxAmount: string;
    isWithholdFedTax: boolean;
    stateTaxPercent: string; //this is not actually received from the API
    stateTaxAmount: string;
    isWithholdStateTax: boolean;
    stateTypeIndicator: string;
    stwProcessCode: string;
    stateTaxAttentionMessage: string;
    stateTaxAttentionRequired: boolean;
    isCashieringIRAAgreementOpened: boolean;
    rmdAnnualAmount: string;
    rmdAnnualPaidYearToDateAmount: string;
    isRmdToDisplay: boolean;
    taxValueOriginMessage: string;
    distributionReason: DistributionReason;
    distributionReasonMap: DistributionReason[];
    nraAccountIndicator: boolean;
}
